import { action } from "satcheljs";

const resetTeamData = action(
    "RESET_TEAM_DATA", () => ({})
);

export default resetTeamData;
